<template>
  <span v-html="formattedHtml" class="whitespace-pre-wrap break-words"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  text: string
}

const props = defineProps<Props>()

const formattedHtml = computed(() => {
  let html = props.text

  html = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  html = html.replace(
    /```(.*?)```/g,
    '<code class="bg-black/10 dark:bg-white/10 px-1 py-0.5 rounded text-sm font-mono">$1</code>',
  )

  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>')

  html = html.replace(/_(.*?)_/g, '<em>$1</em>')

  html = html.replace(/~(.*?)~/g, '<del>$1</del>')

  html = html.replace(
    /&gt; (.+?)(?=<br>|$)/g,
    '<span class="block mt-2 pt-2 border-t border-current/20 text-xs italic opacity-70">$1</span>',
  )

  html = html.replace(/\n/g, '<br>')

  return html
})
</script>
